<template>
    <div class="ma-0 pa-0" :key="this.$route.params.journal_id">
        <!-- Editorial board -->
        <router-link v-if="currentTabComponent== 'AppEditorialBoard'" :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
            <v-btn small class="mr-3 mr-lg-5 body-1 blue darken-4 nottransform">
                <span class="  white--text" >Editorial board</span>
                <span class=" ml-2 caretdown"></span>
            </v-btn>
        </router-link>
        <router-link v-else :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'editorial'}}">
            <v-btn text small class="mx-0 mr-lg-1 dropdown-toggle body-2 blue--text text--darken-4 nottransform">
                Editorial <br v-if="width >= 650"/>board
            </v-btn>
        </router-link>
        <br v-if="width < 650"/>
        <!-- Instructions -->
        <router-link v-if="currentTabComponent== 'AppInstructions'" :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
            <v-btn small class="red mr-3 mr-lg-5 body-1 blue darken-4 nottransform">
            <span class="  white--text" >Instructions for authors</span>
             <span class=" ml-2 caretdown"></span>
            </v-btn>
        </router-link>
        <router-link v-else :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'instructions'}}">
            <v-btn text small  class="mx-0 mr-lg-1 dropdown-toggle body-2 blue--text text--darken-4 nottransform">
                Instructions <br v-if="width >= 650"/>for authors
            </v-btn>
        </router-link>
        <br v-if="width < 650"/>
        <!-- Subscription -->
        <router-link v-if="currentTabComponent== 'AppSubscription'" :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
            <v-btn small class="mb-4 mb-sm-0 mr-3 mr-lg-5 body-1 blue darken-4 nottransform">
                <span class="  white--text" >Subscription</span>
                <span class=" ml-2 caretdown"></span>
            </v-btn>
        </router-link>
        <router-link v-else :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'sub'}}">
            <v-btn text small class="mx-0 mr-lg-1 mb-4 dropdown-toggle body-2 blue--text text--darken-4 nottransform">
                Subscription
            </v-btn>
        </router-link>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
export default {
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return {
            number_to_bo_journal : {
                1 : "am.journal.bo",
                2 : "cmj.journal.bo",
                3 : "mb.journal.bo",
            }
        };
    },
    computed:{
        ...mapGetters('library',{
            currentTabComponent:'currentTabComponent',
            bismenudown:'bismenudown',
            journal:'journal',
        }),
        ...mapGetters('header',{
            width:'width',
        }),
    },
    methods:{
        ...mapActions('library',{
            setCurrentTabComponent:'setCurrentTabComponent',
            setBismenudown:'setBismenudown',
        }),
        ...mapActions('header',{
            set_width:'set_width',
        }),
        onResize(e) {
            const { scrollWidth, scrollHeight } = e;
            this.set_width(scrollWidth);
        },
        getJournalRouteName() {
            if (this.bo) {
                let journal_name = this.number_to_bo_journal[parseInt(this.$route.params.journal_id)];
                if (journal_name) {
                    return journal_name;
                } else {
                    log.error("Could not translate number " + parseInt(this.$route.params.journal_id) + " into journal name");
                    // this will wrongly move the user to the non-bo page
                    return 'journal'; 
                }
            } else {
                return 'journal';
            }
        }
    },
}
</script>
<style  scoped>
.btnblue {
     background-color:rgb(37,38,151);
}
.caretdown {
    border-bottom: 10px solid #FFFFFF;
    border-left: 6px solid rgba(0, 0, 0, 0);
    border-right: 6px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    height: 0;
    vertical-align: top;
    width: 0;
}
.nottransform{
    text-transform: none !important;
}
</style>
